<template>
  <div class="grid-view parent-wrapper">
    <tab-query-page
      ref="queryPage"
      :properties="properties"
      :account-set="accountSet"
      :has-voucher="1"
      :show-batch="false"
      :voucher-page="1"
      :pre-bank-slip-states="preBankSlipStates"
    />
  </div>
</template>

<script>
import TabQueryPage from '@/views/cargo/v0/FinanceManage/VoucherMaintenance/TabQueryPage'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'

export default {
  name: 'VoucherQuery',
  components: { TabQueryPage },
  props: {
    accountSet: { type: Object } // 账套
  },
  data() {
    return {
      properties: {
        activeTabName: 'jobQuery'
      },
      preBankSlipStates: [ClearingConstants.BANK_SLIP_VOUCHER_STATES.code]
    }
  }
}
</script>
